// extracted by mini-css-extract-plugin
module.exports = {"Section1Card":"Section1Card_Section1Card__2pyDB"};